import { render } from "./Lightbox.vue?vue&type=template&id=5f782cf2&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=ts"
export * from "./Lightbox.vue?vue&type=script&lang=ts"

import "./Lightbox.vue?vue&type=style&index=0&id=5f782cf2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f782cf2"

export default script